import { showSummary } from '../compute-summary.js'
import { showGrid } from '../detailed-check/show-grid.js'
import { showFriendlyGrid } from '../friendly-check/show-friendly-grid.js'
import { loadData } from './load-data.js'

export async function executeCheck (checkParams = {}) {
  const loadedData = await loadData({
    accountingOrganisationId: checkParams.accountingOrganisationId,
    monthISO: checkParams.monthISO,
    numberMonths: checkParams.numberMonths || 1,
    queryTrackings: checkParams.queryTrackings || []
  })

  const summaryData = showSummary('comparisonResults', loadedData)
  showFriendlyGrid('friendlyGrid', loadedData)

  const showDetails = false
  if (showDetails) {
    showGrid('detailsGrid', loadedData.rows)
  }

  return {
    loadedData,
    summaryData
  }
}
